
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class editGWattMinLayerModal extends Vue {

    @Prop() productionProcessName: string;
    @Prop() emissionCalculation: OM.GWattMinModel;
    @Prop() saveCallback: (updatedModel: OM.GWattMinModel) => void;

    localModel = new OM.GWattMinModel();

    created() {
        this.localModel = this.emissionCalculation;
    }

    get disabled(){
        return !this.localModel.grams.value || !this.localModel.watt.value || !this.localModel.minutes.value;
    }

    save() {
        this.saveCallback(this.localModel);
    }
}
